import { useLocation } from 'react-router';

export const useTruncatedLocation = () => {
  const location = useLocation();

  if (location.search.length > 500) {
    return location.pathname;
  }

  return `${location.pathname}${location.search}`;
};
